/** @jsxImportSource @emotion/react */
import { Container } from "basis";
import { ReactNode } from "react";
import { CreditCard } from "../CreditCard/CreditCard";

interface Props {
  cardName: string;
  cardEndsWith?: string;
  footer?: ReactNode;
}
export const AccountOption = ({ cardName, cardEndsWith, footer }: Props) => (
  <div css={{ flexGrow: 1 }}>
    <CreditCard cardName={cardName} cardEndsWith={cardEndsWith} />
    {footer && <Container margin="3 0 0 0">{footer}</Container>}
  </div>
);
